import React, { useMemo, useState } from "react";
import { Modal } from "@t8891/pc-v1";
import styles from "./index.module.less";
import { CrossIcon, SuccessIcon } from "@t8891/icon";
import { IOptions } from "@Types/common";
import { Form, Input, message, Select } from "antd";
import classNames from "classnames";
import { useSetState } from "ahooks";
import { Button } from "@t8891/pc";
import { useQuery } from "react-query";
import QRCode from "qrcode.react";
import Cookies from "js-cookie";
import { host } from "@Api";
import { fetchInquiryBuyCarInformationOption, fetchInquiryPreallocate } from "@Services/api";

export interface IInquiryOptions {
  buyCarTime: IOptions[];
  contactTime: IOptions[];
  inquiryStory: IOptions[];
  fields: string[];
  crossRegion: IOptions[];
  banner: {
    image: string;
    link: string;
  };
}
interface InquiryProcessModalProps {
  visible: boolean;
  modalTitle?: string;
  description?: string;
  inquiryId: string;
  setVisible: (value: boolean) => void;
  onSubmit?: (value: any, initFunc: () => void) => void;
}

enum EFields {
  BUY_CAR_TIME = "buyCarTime",
  CROSS_REGION = "crossRegion",
  INQUIRY_STORY = "inquiryStory",
  IS_SEE_CAR = "isSeeCar",
  CONTACT_TIME = "contactTime",
}

type BuyCarInformation = {
  inquiryId?: string;
  contactTime?: string | number;
  buyCarTime?: string | number;
  paymentType?: string;
  region?: string;
  isSeeCar?: 1 | 2;
  brandId?: string;
  crossRegion: any;
  kindId?: string;
  inquiryStory?: string | number;
  inquiryStoryRemark?: string;
};

const initOptions = [];

const formItemLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 10 },
};

const InquiryProcessModal = (props: InquiryProcessModalProps) => {
  const { visible, setVisible, modalTitle = "詢價成功", description, inquiryId, onSubmit } = props;
  const [buyCarDefaultInformation, setBuyCarDefaultInformation] = useSetState<any>({});
  const [buyCarInformation, setBuyCarInformation] = useSetState<any>({});
  const [appUploadVisible, setAppUploadVisible] = useState(false);
  const linkUrL = `${host.c}/m/buyCar/deals?utm_source=8891&utm_medium=line`;
  const { Option } = Select;

  const { data } = useQuery(
    [`fetchInquiryBuyCarInformationOption`, inquiryId],
    async () => {
      const res = await fetchInquiryBuyCarInformationOption({ inquiryId });
      if (res?.status === 12000) {
        res.data.options.forEach((item) => {
          setBuyCarInformation({ [item.key]: null });
          setBuyCarDefaultInformation({ [item.key]: null });
        });
        return res.data.options;
      }
      return initOptions;
    },
    {
      initialData: initOptions,
    },
  );

  const { data: content = "" } = useQuery(
    ["fetchInquiryPreallocate", inquiryId],
    async () => {
      if (!inquiryId) return "";
      const res = await fetchInquiryPreallocate({ inquiryId });
      if (!res) return "抱歉！當前XX市暫無精選業代，等待時間可能較長唷！";
      if (res.status === 12000) return res.data?.message;
      return "抱歉！當前XX市暫無精選業代，等待時間可能較長唷！";
    },
    { enabled: !!inquiryId },
  );

  const checkParams = (params) => {
    const hasNullValue = Object.values(buyCarInformation).some(value => value === null);

    if (hasNullValue) {
      message.error("請選擇補充資料")
    } else {
      onSubmit?.(params, () => {
        setBuyCarInformation(buyCarDefaultInformation);
      });
    }
  };

  const title = useMemo(() => {
    return (
      <section className={styles["modal-title"]}>
        <div className={styles["modal-title"]}>
          <SuccessIcon size={40} fill='#37AF50' />
          <div className={styles["modal-title-text"]}>{modalTitle}</div>
        </div>
      </section>
    );
  }, [modalTitle, description]);

  const onFinish = (values: any) => {
    console.log("Received values of form: ", values);
  };

  return (
    <>
      <Modal
        maskClosable={true}
        className={styles["code-modal"]}
        closeLocation='top'
        visible={appUploadVisible}
        title={"掃描查看我的活動"}
        onClose={() => setAppUploadVisible(false)}
      >
        <div className={styles["qrcode"]}>
          <QRCode
            value={linkUrL} // 生成二维码的内容
            size={144} // 二维码的大小
            fgColor='#000000' // 二维码的颜色
            style={{
              position: "absolute",
              top: "15px",
              left: "35px",
            }}
          />
        </div>
      </Modal>

      <Modal
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        className={styles["modal"]}
        title={title}
      >
        <>
          <CrossIcon
            className={styles["cross-icon"]}
            size={12}
            fill='#333'
            onClick={() => {
              setVisible(false);
            }}
          />
          {/* 
          {banner && banner.image !== "" && (
            <div
              className='flex justify-center'
              onClick={() => {
                setAppUploadVisible(true);
              }}
            >
              <img src={banner.image} height={160} className='my-20 object-cover' />
            </div>
          )} */}
          <section className={styles["modal-content"]}>
            <div className={styles["modal-content-title"]}>
              補充購車資訊
              <span className={styles["modal-content-desc"]}> （您的資料不會公開，請放心填寫！）</span>
            </div>
            {data &&
              data.length > 0 &&
              data?.map((comp: any) => (
                <div className={styles["modal-content-select"]}>
                  <div className={styles["modal-content-select-title"]}>{comp.label}</div>
                  <div className={styles["modal-content-select-value"]}>
                    <Select
                      placeholder={`請選擇${comp.label}`}
                      onChange={(value) => {
                        setBuyCarInformation({ [comp.key]: value });
                      }}
                      value={buyCarInformation[comp.key]}
                    >
                      {Array.isArray(comp.item) &&
                        comp.item?.map((item) => (
                          <Option value={item.value} key={item.label}>
                            {item.label}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>
              ))}
          </section>
          <div className={styles["modal-button"]}>
            <Button
              block
              size='large'
              type='primary'
              onClick={() => {
                checkParams?.(buyCarInformation);
              }}
            >
              確認
            </Button>
          </div>
        </>
      </Modal>
    </>
  );
};

export default InquiryProcessModal;
